// 评审维度
import { RootObject, Content7} from '../../type';
import './style.less';

const ReviewDimension = (props: RootObject["reviewDimension"]) => {
    const {
        zhTitle,
        enTitle,
        content
    } = props;
    return (
        <div className='p-p-foundathon-reviewDimension'>
            <div className='p-p-foundathon-reviewDimension-zh-title'>
                {
                    zhTitle ?? ''
                }
            </div>
            <div className='p-p-foundathon-reviewDimension-en-title'>
                {
                    enTitle ?? ''
                }
            </div>
            <div className='p-p-foundathon-reviewDimension-modules'>
                {
                    content.map((item: Content7, index: number) => {
                        return (
                            <div className='p-p-foundathon-reviewDimension-modules-module' key={index}>
                               
                                <div className='p-p-foundathon-reviewDimension-modules-module-content'>
                                    <div className='p-p-foundathon-reviewDimension-modules-module-content-scale-title'>
                                        {
                                            item.scaleTitle ?? ''
                                        }
                                    </div>
                                    <div className='p-p-foundathon-reviewDimension-modules-module-content-zh-title'>
                                        {
                                            item.title ?? ''
                                        }
                                    </div>
                                    <div className='p-p-foundathon-reviewDimension-modules-module-content-zh-desc'>
                                        {
                                            item.desc ?? ''
                                        }
                                    </div>
                                  
                                   
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default ReviewDimension;